<template>
  <div class="shortcut-select-checked">
    <div class="shortcut-select-checked__header">
      已选择{{ `  (${dataList.length}/${limitCount})` }}
    </div>
    <el-scrollbar class="shortcut-select-checked__list">
      <li
        v-for="(item, index) in props.dataList"
        :key="item[props.defaultProps.key]"
        class="shortcut-select-checked__item"
      >
        <span class="shortcut-select-checked__txt">{{ item.name }}</span>
        <i class="icon-close-large-line t-iconfont" @click="del(item, index)"></i>
      </li>
    </el-scrollbar>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
// emits
const emit = defineEmits(['update:data-list'])
// props
const props = defineProps({
  limitCount: {
    type: Number,
    default: 200
  },
  dataList: {
    type: Array,
    default: () => []
  },
  defaultProps: {
    type: Object,
    default: () => ({
      label: 'name',
      key: 'key'
    })
  }
})
// computed
const dataListControl = computed({
  set(val) {
    emit('update:data-list', val)
  },
  get() {
    return props.dataList
  }
})
// methods
const del = (data, index) => {
  dataListControl.value.splice(index, 1)
}
// lice-cycle
onMounted(() => {})
</script>

<style lang="less" scoped>
.shortcut-select-checked {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 16px 0;

  &__header {
    // display: flex;
    // height: 32px;
    color: #969799;
    font-size: 14px;
    line-height: 20px;
    // align-items: center;
  }
  &__list {
    width: 100%;
    margin-top: 12px;
    :deep(.el-scrollbar__view) {
      display: flex;
      flex-wrap: wrap;
    }
    // flex-grow: 1;
    // display: flex;
    // flex-wrap: wrap;
  }
  &__txt {
    // padding: 0 8px;
    font-size: 14px;
    // color: $text-plain;
    // color: #646566;
    color: #323233;
    // @include singleline-ellipsis();

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__item {
    box-sizing: border-box;
    display: flex;
    align-items: baseline;
    max-width: 95%;
    // height: 20px;
    padding: 4px 8px;
    margin: 0 8px 8px 0;
    line-height: 20px;
    gap: 8px;
    // background: $bg-table;
    background: #f7f8fa;
    border-radius: var(--el-border-radius-base);
    .t-iconfont {
      display: inline-block;
      font-size: 12px;
      line-height: 12px;
      // color: $text-auxiliary;
      color: #969799;
    }
    .icon-close-large-line {
      cursor: pointer;
      &:hover {
        // color: $brand-base-color-6;
      }
    }
  }
}
</style>
